import { ResourceType } from "@/game/entities/config/resources";
import useUpgradesStore from "@/store/useUpgradesStore";
import type { UpgradeParams } from "@/types/tile";
import { FrameName } from "../config";
import { UpgradeIds } from "../config/upgrades";
import { EventUpgradeIds } from "../config/upgrades/";
import TileEntity from "../TileEntity";

class HillsTerrainTileEntity extends TileEntity {
	public static readonly frameName = FrameName.HILLS;

	public get upgrades(): Map<FrameName, UpgradeParams> {
		if (this.cachedUpgrades) return this.cachedUpgrades;

		const upgrades = new Map<FrameName, UpgradeParams>(
			super.config.upgrades,
		);

		if (
			useUpgradesStore().getCurrentLevelById(UpgradeIds.highlanders) > 0
		) {
			upgrades.set(FrameName.LUMBER_MILL, {
				price: {
					[ResourceType.COINS]: 1_500,
				},
			});
			upgrades.set(FrameName.INDUSTRIAL_LUMBER_MILL, {
				price: {
					[ResourceType.GEMS]: 50,
				},
			});
		}

		if (
			useUpgradesStore().getCurrentLevelById(
				EventUpgradeIds.ch_highlanders,
			) > 0
		) {
			upgrades.set(FrameName.DARKWOOD_LUMBER_MILL, {
				// Budova ide zo storage.
			});
		}

		return (this.cachedUpgrades = new Map<FrameName, UpgradeParams>(
			upgrades,
		));
	}
}

export default HillsTerrainTileEntity;
